<template>
  <div>
    <v-app-bar height="90" color="white" elevation="0">
      <v-row justify="center" no-gutters>
        <v-col></v-col>
        <v-col cols="12">
          <v-container class="d-flex align-center">
            <v-app-bar-nav-icon
              class="mr-4"
              color="grey"
              @click="drawer = true"
              v-if="getCouncilId == null"
            >
              <template>
                <v-icon>fal fa-bars</v-icon>
              </template>
            </v-app-bar-nav-icon>

            <router-link :to="logoUrl">
              <logo :url="getCouncilImage" alt="Benfeitores Logo" width="90" />
            </router-link>
            <v-spacer></v-spacer>

            <!-- minhas doacoes ################## -->
            <router-link
              :to="{ name: routes.web.ListDonations }"
              v-if="getCouncilId != null"
            >
              <v-btn class="mr-2" icon>
                <v-icon color="var(--gray)">fal fa-hands-usd</v-icon>
              </v-btn>
            </router-link>

            <!-- fale conosco ################## -->
            <v-btn class="mr-2" icon @click="showContactUs = !showContactUs">
              <v-icon
                :key="`icon-${showContactUs}`"
                :color="showContactUs ? 'red' : 'var(--gray)'"
                v-text="showContactUs ? 'fas fa-envelope' : 'fal fa-envelope'"
              ></v-icon>
            </v-btn>

            <!-- notification btn ################## -->
            <!-- <v-badge
                            color="error"
                            offset-x="20"
                            offset-y="20"
                            size="2"
                            content="6"
                            class="mr-4"
                        >
                            <v-btn icon @click="userDrawer = true; tab = 'notification'">
                                <v-icon size="20" color="var(--gray)">fal fa-bell</v-icon>
                            </v-btn>
                        </v-badge> -->

            <!-- perfil avatar ################## -->
            <v-btn
              icon
              @click="
                userDrawer = true;
                tab = 'profile';
              "
            >
              <v-avatar size="40">
                <img
                  :src="`https://ui-avatars.com/api/?name=${name}&background=F8F7FC&color=CCCDDD&size=512`"
                />
              </v-avatar>
            </v-btn>
          </v-container>
        </v-col>
        <v-col cols="12"></v-col>
      </v-row>
    </v-app-bar>

    <!-- MENU ADMIN #############################################################-->
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      v-if="getCouncilId == null"
    >
      <v-list nav>
        <v-list-item-group tile active-class="secondary white--text">
          <v-list-item
            v-if="hasFinancialPersmission"
            :to="{ name: routes.app.Finance }"
          >
            <v-list-item-icon>
              <v-icon>fal fa-usd-square</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Financeiro</v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasReceiptPermission" :to="{ name: routes.app.Receipts }">
            <v-list-item-icon>
              <v-icon>fal fa-file-signature</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Recibos</v-list-item-content>
          </v-list-item>

          <v-list-item
            :to="{ name: routes.app.Dashboard }"
            v-if="hasDashboardPermission"
            exact
          >
            <v-list-item-icon>
              <v-icon>fal fa-users-class</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Dashboard</v-list-item-content>
          </v-list-item>

          <v-subheader>Gestão</v-subheader>

          <v-list-item
            :to="{ name: routes.app.InstitutionManagement }"
            v-if="hasInstitutionManagementPermision"
          >
            <v-list-item-icon>
              <v-icon>fal fa-hands-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Instituições</v-list-item-content>
          </v-list-item>

          <v-list-item
            :to="{ name: routes.app.CouncilManagement }"
            v-if="hasCouncilManagementPermission"
          >
            <v-list-item-icon>
              <v-icon>fal fa-atlas</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Conselhos</v-list-item-content>
          </v-list-item>

          <v-list-item
            :to="{ name: routes.app.UserManagement }"
            v-if="hasUserManagementPermission"
          >
            <v-list-item-icon>
              <v-icon>fal fa-users-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Usuários</v-list-item-content>
          </v-list-item>

          <v-list-item
            :to="{ name: routes.app.AgentsManagement }"
            v-if="hasAgentManagementPermission"
          >
            <v-list-item-icon>
              <v-icon>fal fa-id-badge</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Agentes de doação</v-list-item-content>
          </v-list-item>

          <v-list-item
            :to="{ name: routes.app.SecretarysManagement }"
            v-if="hasSecretaryManagementPermission"
          >
            <v-list-item-icon>
              <v-icon>fal fa-users-class</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Secretarias</v-list-item-content>
          </v-list-item>
          <!-- <v-list-item
            :to="{ name: routes.app.FundysManagement }"
            v-if="hasSecretaryManagementPermission"
          >
            <v-list-item-icon>
              <v-icon>fal fa-users-class</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Fundos</v-list-item-content>
          </v-list-item> -->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <!-- / MENU ADMIN ###########################################################-->

    <!-- RIGHT TAB BAR - USER & NOTIFICATIONS #############################################################-->
    <v-navigation-drawer
      v-model="userDrawer"
      absolute
      temporary
      right
      width="360px"
      class="userBar"
    >
      <v-tabs fixed-tabs v-model="tab" color="secondary">
        <!-- <v-tab href="#notification">Notificações</v-tab> -->
        <v-tab href="#profile">Perfil</v-tab>

        <!-- <v-tab-item :transition="false" :reverse-transition="false" value="notification">
                    <v-list two-line subheader> -->
        <!-- notitication ########################################### -->
        <!-- <v-list-item justify="center">
                            <v-list-item-avatar>
                                <v-icon>👍</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-subheader inset class="pl-0 my-1">Dica</v-subheader>
                                <div class="msg">Lembre-se de manter seu perfil sempre atualizado.</div>
                                <v-list-item-subtitle>a 5 min</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action class="align-self-start">
                                <v-btn icon>
                                    <v-icon small color="var(--gray)">fal fa-times</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider></v-divider> -->

        <!-- notitication ########################################### -->
        <!--<v-list-item justify="center">
                            <v-list-item-avatar>
                                <v-icon>❤️</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-subheader inset class="pl-0 my-1">Aviso</v-subheader>
                                <div class="msg">Você fez uma doação no valor de R$23.000,00</div>
                                <v-list-item-subtitle>a 30 min</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action class="align-self-start">
                                <v-btn icon>
                                    <v-icon small color="var(--gray)">fal fa-times</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider></v-divider>
                    </v-list>
                </v-tab-item> -->
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          value="profile"
        >
          <v-layout align-center pa-8 column>
            <v-flex>
              <v-avatar size="140">
                <img
                  :src="`https://ui-avatars.com/api/?name=${name}&size=160`"
                  alt
                />
              </v-avatar>
            </v-flex>
            <v-flex text-center>
              <h3 class="font-weight-light">{{ name }}</h3>
              <span class="gray--text">{{ email }}</span>
            </v-flex>
            <v-flex mt-8>
              <button @click="GoToProfile()" :key="$route.path">
                <v-btn rounded outlined color="var(--gray)" class="px-6 mr-3">
                  <v-icon small class="mr-2">fal fa-pen</v-icon>Editar Perfil
                </v-btn>
              </button>

              <v-btn
                rounded
                outlined
                color="var(--gray)"
                class="px-6"
                @click="logOut()"
              >
                <v-icon small class="mr-2">fal fa-power-off</v-icon>Sair
              </v-btn>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </v-navigation-drawer>
    <!-- / MENU ADMIN ###########################################################-->

    <!-- Breadcrumb ###########################################################
    <v-container fluid pa-0 class="breadcrumb">
      <v-container>
        <v-breadcrumbs class="pa-0" :items="items">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-container>
    </v-container> -->

    <ContactUs v-model="showContactUs" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Logo from "@/components/Logo";
import AuthService from "@/scripts/services/auth.service";
import TokenService from "@/scripts/services/base/token.service";
import Routes from "@/router/names.js";
import router from "@/router/index";

export default {
  components: {
    Logo
  },

  data: () => ({
    routes: Routes,
    authService: new AuthService(),
    name: "",
    email: "",
    userDrawer: false,
    drawer: false,
    showContactUs: false,
    tab: ""
  }),
  computed: {
    ...mapGetters(["getCouncilImage", "getCouncilId"]),
    ...mapGetters("userModule", [
      "hasFinancialPersmission",
      "hasReceiptPermission",
      "hasInstitutionManagementPermision",
      "hasCouncilManagementPermission",
      "hasUserManagementPermission",
      "hasSecretaryManagementPermission",
      "hasAgentManagementPermission",
      "hasDashboardPermission"
    ]),
    items() {
      const meta = this.$route.meta;
      let list = [];
      if (meta) {
        if (meta.nav) {
          for (let i = 0; i < meta.nav.length; i++) {
            let current = meta.nav[i];
            let route = router.options.routes.find(r => r.name == current);
            if (route && route.meta && route.meta.name) {
              list.push({
                text: route.meta.name,
                exact: true,
                to: { name: current }
              });
            }
          }
        }
        if (meta.name) {
          list.push({
            text: meta.name,
            exact: true,
            to: { name: this.$route.name }
          });
        }
      }
      return list;
    },
    logoUrl() {
      if (this.getCouncilId == null) {
        return { name: Routes.app.Dashboard };
      }
      return { name: Routes.web.Start };
    }
  },
  mounted() {
    if (localStorage.getItem("name") && localStorage.getItem("email")) {
      try {
        this.name = JSON.parse(localStorage.getItem("name"));
        this.email = JSON.parse(localStorage.getItem("email"));
      } catch (e) {
        localStorage.removeItem("name");
        localStorage.removeItem("email");
      }
    } else {
      var isAgent = localStorage.getItem("is_agent");
      if (isAgent == "true") {
        this.authService.loadAgentNameAndEmail().then(this.fillData);
      } else {
        this.authService.loadUserNameAndEmail().then(this.fillData);
      }
    }
  },
  methods: {
    ...mapActions(["setSelectedAgent"]),
    fillData(data) {
      this.name = data.name;
      this.email = data.email;

      const parsedName = JSON.stringify(this.name);
      const parsedEmail = JSON.stringify(this.email);

      localStorage.setItem("name", parsedName);
      localStorage.setItem("email", parsedEmail);
    },
    logOut() {
      TokenService.removeToken();
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      if (this.getCouncilId)
        this.$router.push({ name: Routes.web.LoginCouncil });
      else this.$router.push({ name: Routes.web.Login });
    },
    GoToProfile() {
      var isAgent = localStorage.getItem("is_agent");

      if (isAgent == "true") {
        this.$router.push({ name: Routes.web.Profile });
      } else {
        this.setSelectedAgent(null);
        this.$router.push({ name: Routes.web.UserProfile });
      }
    }
  }
};
</script>